// North American booking timezones (Newfoundland → Pacific). Value is an IANA zone.
export const TIMEZONES = [
  { value: "America/St_Johns", label: "Newfoundland Time (GMT-3:30)" },
  { value: "America/Halifax", label: "Atlantic Time (GMT-4)" },
  { value: "America/Toronto", label: "Eastern Time (GMT-5)" },
  { value: "America/Winnipeg", label: "Central Time (GMT-6)" },
  { value: "America/Edmonton", label: "Mountain Time (GMT-7)" },
  { value: "America/Vancouver", label: "Pacific Time (GMT-8)" },
];

export const DEFAULT_TZ = "America/Halifax";

export const tzLabel = (value) =>
  (TIMEZONES.find((t) => t.value === value) || TIMEZONES[1]).label;

const getTzParts = (instant, tz) => {
  const fmt = new Intl.DateTimeFormat("en-US", {
    timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hour12: false,
  });
  const p = Object.fromEntries(
    fmt.formatToParts(instant).filter((x) => x.type !== "literal").map((x) => [x.type, x.value])
  );
  return { year: +p.year, month: +p.month, day: +p.day, hour: +p.hour % 24, minute: +p.minute };
};

// Convert a wall-clock time (y, monthIndex 0-11, day, minutesOfDay) in tz to the matching UTC Date.
export const zonedWallToUtc = (y, monthIndex, day, minutes, tz) => {
  const hour = Math.floor(minutes / 60), min = minutes % 60;
  const asUTC = Date.UTC(y, monthIndex, day, hour, min);
  const p = getTzParts(new Date(asUTC), tz);
  const back = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute);
  return new Date(asUTC - (back - asUTC));
};

// Current wall-clock in tz as { y, monthIndex, day, minutes }.
export const nowInTz = (tz) => {
  const p = getTzParts(new Date(), tz);
  return { y: p.year, monthIndex: p.month - 1, day: p.day, minutes: p.hour * 60 + p.minute };
};

// Wall-clock parts of an arbitrary instant in tz as { y, monthIndex, day, minutes }.
export const zonedParts = (instant, tz) => {
  const p = getTzParts(instant, tz);
  return { y: p.year, monthIndex: p.month - 1, day: p.day, minutes: p.hour * 60 + p.minute };
};
